export default __webpack_public_path__ + "images/logoNonGenderSpecific.cf448caf24d058d8c853ef0027f3b113.svg"